import { FieldValues, useController, Validate } from 'react-hook-form';
import {
  DateRangeValue,
  DateTimeRangePickerProps,
  DateTimeRangeTimezonePicker,
} from 'shared/mui/DatePicker/DateTimeRangeTimezonePicker/DateTimeRangeTimezonePicker';
import { useFilterTimezone } from 'shared/mui/Filter/hooks/useFilterTimezone';

type DateRangeValidate = Validate<DateRangeValue, FieldValues>;

export type DateTimeRangeTimezoneInputProps = Omit<
  DateTimeRangePickerProps,
  | 'value'
  | 'onChange'
  | 'onBlur'
  | 'error'
  | 'helperText'
  | 'name'
  | 'timezone'
  | 'onChangeTimezone'
> & {
  source: string;
  timezoneSource?: string;
  validate?: DateRangeValidate | Record<string, DateRangeValidate>;
};

export const DateTimeRangeTimezoneInput: React.FC<DateTimeRangeTimezoneInputProps> = ({
  source,
  timezoneSource = 'timezone',
  validate,
  ...restProps
}) => {
  const {
    field: { onChange, onBlur, value },
    fieldState: { error },
  } = useController({ name: source, rules: { validate } });
  const { timezone, onChangeTimezone } = useFilterTimezone(timezoneSource);

  return (
    <DateTimeRangeTimezonePicker
      {...restProps}
      error={!!error}
      helperText={error?.message}
      onBlur={onBlur}
      onChange={onChange}
      onChangeTimezone={onChangeTimezone}
      timezone={timezone}
      value={value}
    />
  );
};
